export default __webpack_public_path__ + "static/d-sizzling2-37a363e0d98f6ec0f608618c9147af60.jpg";